import { ProcedimentoConflitoDTO } from "../dtos/procedimento-conflito-dto";
import { ProcedimentoAgenda } from "./procedimento-agenda/procedimento-agenda";
import { ProcedimentoConflito } from "./procedimento-conflito/procedimento-conflito";

export class Procedimento {

    id: number = 0;

    nome: string = '';

    tipoAgendamento: string = '';

    agenda: Array<ProcedimentoAgenda> = [];

    conflitos: Array<ProcedimentoConflito> = [];

    conflitosDTO: Array<ProcedimentoConflitoDTO> = [];

    dilataPupila: boolean = false;

    executaPosDilatacao: boolean = false;

    disponivel: boolean = false;

    procedimentoConsulta: boolean = false;

    valor: number = 0.00;

    apelido: string = '';

    observacao: string = '';

    cobrarProcedimento: boolean = true;

    dilataPupilaFormatado: string = '';

    executaPosDilatacaoFormatado: string = '';

    disponivelFormatado: string = '';

    procedimentoConsultaFormatado: string = '';

    tipoAgendamentoFormatado: string = '';

    recomendacoes: string = '';

    observacaoSelecao: string = '';

    constructor() {
    }
}
